import { MuiIconNames } from '@features/cms/typings/material-icon-font'

export const quickTipConfigSchema = {
  type: 'object',
  properties: {
    iconName: { type: 'string', enum: MuiIconNames },
    iconBackgroundColor: { type: 'string' }
  }
}
